$('.js-mobile').on('click', function () {
  $(this).toggleClass('l-header__mobile--open');
  $('.l-header').toggleClass('l-header--open');
  $('.l-header__menu').slideToggle(200);
  $('.l-header__meta').slideToggle(400);
});